import { EntityType, ENTITY_TYPE_SHORTCUTS } from "@/types/search";

export interface ParsedSearch {
  rawQuery: string;
  parsedQuery: string;
  entityFilter: EntityType[] | undefined;
  isIdSearch: boolean;
}

export function parseSearchInput(input: string): ParsedSearch {
  const trimmed = input.trim();

  // Handle @ prefix for entity type filtering
  if (trimmed.startsWith("@")) {
    const spaceIndex = trimmed.indexOf(" ");
    const typeHint =
      spaceIndex > 0 ? trimmed.slice(1, spaceIndex) : trimmed.slice(1);
    const query = spaceIndex > 0 ? trimmed.slice(spaceIndex + 1) : "";
    const entityFilter = ENTITY_TYPE_SHORTCUTS[typeHint.toLowerCase()];

    return {
      rawQuery: input,
      parsedQuery: query,
      entityFilter,
      isIdSearch: false,
    };
  }

  // Handle # prefix for ID/slug search
  if (trimmed.startsWith("#")) {
    return {
      rawQuery: input,
      parsedQuery: trimmed.slice(1),
      entityFilter: undefined,
      isIdSearch: true,
    };
  }

  // Default: fuzzy search all
  return {
    rawQuery: input,
    parsedQuery: trimmed,
    entityFilter: undefined,
    isIdSearch: false,
  };
}

export function getSearchPlaceholder(parsed: ParsedSearch): string {
  if (parsed.entityFilter && parsed.entityFilter.length > 0) {
    const typeNames = parsed.entityFilter
      .map((t) => t.replace("_", " "))
      .join(", ");
    return `Search ${typeNames}...`;
  }
  if (parsed.isIdSearch) {
    return "Enter ID or slug...";
  }
  return "Search everything...";
}
